import React from 'react'
import { T } from 'components/components/i18n'
import Product from './Product'
import RimProduct from './RimProduct'
import Pagination from '../Pagination'
import SortBy from '../SortBy'
import PriceOptions from '../PriceOptions'
import CATEGORIES from '../../../../../helpers/categories'
import styles from './styles.less'
import CompleteWheelProduct from './CompleteWheelProduct'
import { Row, Col } from 'react-bootstrap'

export const ProductsList = (props) => {
  const {
    onSortByClick,
    onPageClick,
    selectedSortOption,
    shop,
    pagination,
    topRank,
    products,
    isPair,
    category,
    sortBy,
    initialSearchDone
  } = props
  const [visibleItems, setVisibleItems] = React.useState(8)
  const loadMoreRef = React.useRef(null)
  const hasFirstProduct = products[0] && products[0].id

  React.useEffect(() => {
    const _loadMoreRef = loadMoreRef.current
    if (isPair && window.IntersectionObserver) {
      setVisibleItems(8)
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setVisibleItems((prevVisibleItems) => prevVisibleItems + 8)
        }
      }, {
        threshold: 1.0
      })

      if (_loadMoreRef) {
        observer.observe(_loadMoreRef)
      }

      return () => {
        if (_loadMoreRef) {
          observer.unobserve(_loadMoreRef)
        }
      }
    }
  }, [isPair, products.length, topRank.length, sortBy, loadMoreRef, hasFirstProduct])

  let productComponents, topRankSection, topRankComponents, paginationComponent, resultsHeader
  if (!initialSearchDone)
    return null
  if (initialSearchDone && products.length === 0 && topRank.length === 0) {
    productComponents = <h4 className={styles.noResults}><T id="Hittade inga produkter för din sökning" /></h4>
  } else {
    let className, productColumns, hasCampaignText = false
    productComponents = []
    topRankComponents = []
    switch(category.id) {
      case CATEGORIES.RIM.id:
        productComponents = products.map(product => <RimProduct product={product} key={product.id}/>)
        className = styles.flexWrapFourColumns
        productColumns = styles.fourColumns
        break
      case CATEGORIES.COMPLETE_WHEEL.id:
        productComponents = products.map(product => <CompleteWheelProduct product={product} key={product.id} />)
        productColumns = styles.threeColumns
        break
      default:
        if (isPair && window.IntersectionObserver) {
          productComponents = products.slice(0, visibleItems).map(product => <Product product={product} isPair={isPair} key={product.id}/>)
        } else {
          productComponents = products.map(product => <Product product={product} isPair={isPair} key={product.id}/>)
          if (topRank.length) {
            Array.from([1, 2, 3]).forEach(position => {
              const product = topRank.filter(item => item?.rank?.group === position)
              const placeholder = shop.topBrandsConfig?.['top_brands']?.[position]?.placeholder
              if (product?.length > 0) {
                const label1 =shop.topBrandsConfig?.['top_brands']?.[position]?.label1 || ''
                const label2 =shop.topBrandsConfig?.['top_brands']?.[position]?.label2 || ''
                if (label1 || label2) {
                  hasCampaignText = true
                }
                topRankComponents.push(
                  <Product
                    key={product[0].id}
                    product={product[0]}
                    isPair={isPair}
                    campaignLabel1={label1}
                    campaignLabel2={label2}
                    isTopRank={true}
                  />
                )
              } else if (placeholder) {
                // TODO: validate valid url
                topRankComponents.push(
                  <li
                    className={`${styles.placeholder} staggered-top-rank`}
                    style={{backgroundImage: `url(${placeholder})`}}
                  ></li>
                )
              }
            })
          }
        }

        if (isPair) {
          className = styles.flexWrap
          productColumns = styles.twoColumns
        } else {
          className = styles.flexWrapFourColumns
          productColumns = styles.fourColumns
        }
    }

    if (topRankComponents.length) {
      const campaignCSS = hasCampaignText ? styles.campaignText : ''
      topRankSection = (
        <div className={`topRankColumnsContainer ${styles.topRankColumnsContainer}`}>
          <ul
            className={`${campaignCSS} list-unstyled ${styles.flexWrap} ${styles.topRankColumns}`}
            key={`topRank-${topRank.length}-${sortBy}-${topRank[0] && topRank[0].id}-${topRank[topRank.length - 1] && topRank[topRank.length - 1].id}`}
          >
            {topRankComponents}
          </ul>
        </div>
      )
    }

    productComponents = (
      <ul
        className={`list-unstyled ${className} ${productColumns}`}
        key={`${products.length}-${sortBy}-${products[0] && products[0].id}-${products[products.length - 1] && products[products.length - 1].id}`}
      >
        {productComponents}
      </ul>
    )
    paginationComponent = isPair ? null : (
      <Pagination
        pagination={pagination}
        shop={shop}
        onPageClick={onPageClick}
      />
    )
    resultsHeader = (
      <Row className={styles.productsListHeader}>
        <Col md={3} sm={12} xs={12}><SortBy onSortByClick={onSortByClick} selectedSortOption={selectedSortOption}/></Col>
        <Col md={9} sm={12} xs={12} className={`${styles.priceOptions} productList_priceOptions`}><PriceOptions /></Col>
      </Row>
    )
  }

  return (
    <div className="products-list">
      {resultsHeader}
      {topRankSection}
      {productComponents}
      {(isPair && visibleItems < products.length) && (
        <div className={styles.loadMore} ref={loadMoreRef}>
          <T id="Loading more..." />
        </div>
      )}
      {paginationComponent}
    </div>
  )
}

export default ProductsList
